/* global $ */

/* Utility function to convert a canvas to a BLOB */
var dataURLToBlob = function(dataURL) {
    var BASE64_MARKER = ';base64,';

    var parts,
        contentType,
        raw,
        rawLength,
        uInt8Array;

    if (dataURL.indexOf(BASE64_MARKER) === -1) {
        parts = dataURL.split(',');
        contentType = parts[0].split(':')[1];
        raw = parts[1];

        return new Blob([raw], {type: contentType});
    }

    parts = dataURL.split(BASE64_MARKER);
    contentType = parts[0].split(':')[1];
    raw = window.atob(parts[1]);
    rawLength = raw.length;

    uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++ i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], {type: contentType});
};

/* End Utility function to convert a canvas to a BLOB      */

function initImageUploader(element) {
    var el = element ? element : 'body';
    $('.imageFileUploadGroup', el).each(function() {
        var thisGroup = $(this);
        thisGroup.find('.removeImage').click(function(e) {
            var remove;
            remove = confirm('Are you sure you want to delete this image?');
            if (remove) {
                $('.imagePathField', thisGroup).val('');
                $('.imageFileThumb', thisGroup).removeAttr('src');
            }
        });

        $('.imagePathField', thisGroup).val($('.imageFileThumb', thisGroup).attr('src'));

    });

    $('.imageFileInput', el).change(function(e) {
        var imageGroup = $(e.target).parent().eq(0);
        var imageCrop = imageGroup.attr('data-image-crop') ? imageGroup.attr('data-image-crop') : false;

        if (imageCrop) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                var img = new Image();

                img.onload = function() {
                    var MAX_WIDTH = 2000;
                    var MAX_HEIGHT = 1125;
                    var ratio = MAX_WIDTH / MAX_HEIGHT;
                    var w = img.width;
                    var h = img.height;
                    var nH,
                        nW,
                        startX = 0,
                        startY = 0;

                    var canvas,
                        dataUrl,
                        resizedImage;

                    if (w / h <= ratio) {
                        // image is taller than desired or perfect
                        if (w > MAX_WIDTH) {
                            // need to resize image cuz too big
                            nW = MAX_WIDTH;
                        } else {
                            nW = w;
                        }

                        nH = nW / ratio;

                    } else {
                        // image is wider than desired
                        if (h > MAX_HEIGHT) {
                            // need to resize image cuz too big
                            nH = MAX_HEIGHT;
                        } else {
                            nH = h;
                        }

                        nW = nH * ratio;
                    }

                    // cropping
                    if (w > nW) {
                        startX = (nW - w) / 2;
                    }
                    if (h > nH) {
                        startY = (nH - h) / 2;
                    }

                    canvas = document.createElement('canvas');
                    canvas.width = nW;
                    canvas.height = nH;
                    canvas.getContext('2d').drawImage(this, startX, startY);

                    this.onload = function() {};
                    this.src = canvas.toDataURL();

                    dataUrl = canvas.toDataURL('image/jpeg');
                    resizedImage = dataURLToBlob(dataUrl);

                    $.event.trigger({
                        type: 'imageResized',
                        blob: resizedImage,
                        formId: 'imageUploadForm',
                        imageGroup: imageGroup
                    });
                };

                img.src = e.target.result;
            };

            fileReader.readAsDataURL(e.target.files[0]);
        } else {
            $.event.trigger({
                type: 'imageResized',
                blob: e.target.files[0],
                formId: 'imageUploadForm',
                imageGroup: imageGroup
            });
        }

        $('.imageFileLoader', imageGroup).text('Please wait while your image uploads.');
    });
}

$(document).on('imageResized', function(event) {
    if (event.blob && event.formId) {
        var f = $('#' + event.formId)[0];
        var data = new FormData(f);
        data.append('image', event.blob);

        $.ajax({
            url: $(f).attr('action'),
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: function(data) {
                $('.imagePathField', event.imageGroup).val(data);
                $('.imageFileThumb', event.imageGroup).attr('src', data);
                $('.imageFileLoader', event.imageGroup).text('Upload Successful! This image will not be saved to your piece of content until you save at the bottom');
            }
        });
    }
});

$(document).ready(function() {
    initImageUploader();
});
